import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, ArrowUpRight } from "lucide-react";

const STEPS = [
  { n: "01", title: "Tell us about your business", body: "5-minute multi-step onboarding wizard. Name, industry, audience, goals, brand color." },
  { n: "02", title: "AI builds your foundation", body: "Within 60 seconds: SWOT, 3 customer personas, 90-day roadmap, brand identity, full marketing website." },
  { n: "03", title: "Connect your channels", body: "OAuth into Instagram, Facebook, LinkedIn, X, YouTube and Google Business — encrypted token storage." },
  { n: "04", title: "AI plans your month", body: "A 30-day content calendar with posts, captions, hashtags and images — all in your brand voice." },
  { n: "05", title: "You approve (or let AI publish)", body: "Per channel: auto-publish, require approval, or admin gate. Sensitive content always escalates to humans." },
  { n: "06", title: "AI engages your customers", body: "Reply Inbox drafts brand-voiced responses to comments, reviews and DMs. You approve in one tap." },
  { n: "07", title: "AI grows your brand", body: "Continuous analytics, insights and growth recommendations. New campaigns generated on demand." },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-[#05050A] text-white grid-bg p-6 lg:p-12" data-testid="how-it-works-root">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-10">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-2 mb-10">
          <div className="h-9 w-9 rounded-lg brand-gradient grid place-items-center">
            <Sparkles className="h-5 w-5" />
          </div>
          <span className="font-heading font-black text-lg tracking-tight">
            MakeYour<span className="brand-gradient-text">Brand.IN</span>
          </span>
        </div>

        <div className="text-xs uppercase tracking-[0.25em] text-orange-400/80 mb-3">How it works</div>
        <h1 className="font-heading text-4xl lg:text-6xl font-black tracking-tighter mb-4 max-w-3xl">
          Setup in 5 minutes. <br />Then it runs itself.
        </h1>

        <div className="mt-14 space-y-2">
          {STEPS.map((s, i) => (
            <div key={s.n} className="grid lg:grid-cols-12 gap-4 py-6 border-t border-white/5" data-testid={`step-${s.n}`}>
              <div className="lg:col-span-2">
                <div className="font-heading font-black text-5xl brand-gradient-text">{s.n}</div>
              </div>
              <div className="lg:col-span-10">
                <h3 className="font-heading font-bold text-2xl">{s.title}</h3>
                <p className="text-white/65 mt-2 leading-relaxed max-w-2xl">{s.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 glass rounded-2xl p-8 lg:p-12">
          <h2 className="font-heading text-3xl font-black tracking-tight">Ready to fire your agency?</h2>
          <p className="text-white/60 mt-2">14-day free trial. No card. 5-minute setup.</p>
          <Link to="/register" className="mt-6 inline-flex items-center gap-2 brand-gradient px-6 py-3.5 rounded-lg text-sm font-semibold hover:opacity-90 glow-orange">
            Start now <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
